// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.PageInfo[data-v-8f3e101a]{\n  display:flex;\n  width:100%;\n  flex-direction:column;\n  align-items:center;\n}\n.PageInfo .LoadMore[data-v-8f3e101a]:disabled{\n      opacity:.5;\n      pointer-events:none\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
